import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { user } from 'services';
// import { getFirstCategory } from 'services/types';
import { deleteEpm } from 'services/payments-service';
import { TableExt, TableInfo, Confirm, themes, GridBox, GridColumnsSetup } from 'libs/ui';
import { useGridColumns } from 'libs/hooks';
import EpmForm from './forms/epm-form';
import { getTableParams } from './grid.params';

export const EpmGrid = (props) => {
  const { count, entries, className, theme, getXlsAction, clientId, updateEntry, getFilter } = props;
  //const interface1 = props.interface;
  const [showForm, setShowForm] = useState('');
  const [row, setRow] = useState({});
  const [confirm, setConfirm] = useState(null);

  const { t } = useTranslation();

  /**
   * close confirm
   */
  const closeConfirm = () => {
    setConfirm(null);
  };

  /**
   * delete item
   */
  const delItem = (id) => {
    deleteEpm(id).then(() => {
      props.getEntries({ offset: 0 }, null, true);
      closeConfirm();
    });
  };

  // actions
  const addItemAction = () => {
    setRow({});
    setShowForm('addForm');
  };

  const editItemAction = (row) => {
    setRow(row);
    setShowForm('editForm');
  };

  const delItemAction = (row) => {
    setRow(row);
    setConfirm({
      title: (
        <>
          {t('messages.СО')} <b>{row.mean_id}</b> {t('messages.будет удалено. Продолжить?')}
        </>
      ),
      width: '440px',
      type: 'danger',
      cancelButton: { text: t('buttons.Отмена'), func: closeConfirm },
      acceptButton: { text: t('buttons.Удалить'), func: () => delItem(row.id), theme: themes.red },
    });
  };

  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  // actions
  const rightEdit = user.haveRight('csc.update');
  const rightDel = user.haveRight('csc.delete');
  const rightAdd = user.haveRight('csc.add');
  const actions = [];

  if (rightDel) {
    actions.push({ title: t('buttons.Удалить'), action: delItemAction });
  }

  // top actions
  const topActions = [];
  if (rightAdd) {
    topActions.push({ title: t('buttons.Добавить'), icon: 'fa-plus', theme: themes.blue, action: addItemAction });
  }
  if (count) {
    getXlsAction(topActions);
  }

  const initial =
    showForm === 'addForm'
      ? {
          is_privileged: false,
        }
      : { ...row };

  const tableParams = useMemo(() => getTableParams(t, clientId), [t, clientId]);
  const { getFields, fields: staticFields, ...restTableParams } = tableParams;
  const defaultFields = useMemo(() => (getFields ? getFields(props) : staticFields), [getFields, staticFields, props]);
  const { fields, columns, toggleColumn, reorderColumns, resetColumns } = useGridColumns('epm', defaultFields);
  topActions.push({ cmp: <GridColumnsSetup key="columns-setup" columns={columns} onToggle={toggleColumn} onReorder={reorderColumns} onReset={resetColumns} /> });

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} actions={topActions} />

      <TableExt
        updateEntry={updateEntry}
        theme={theme}
        title={t('sections.БСК')}
        rows={{ count, items }}
        actions={actions}
        className={className}
        refresh={props.refresh}
        clientId={clientId}
        onRowClick={rightEdit ? editItemAction : undefined}
        getFilter={getFilter}
        {...restTableParams}
        fields={fields}
      />

      {confirm && <Confirm {...confirm} />}

      {showForm && (
        <EpmForm
          type={showForm}
          close={() => setShowForm('')}
          //id={props.id}
          clientId={props.clientId}
          id={row.id}
          meanId={row.mean_id}
          meanType={row.mean_type}
          refresh={props.refresh}
          tariffs={props.tariffs}
          initialValues={initial}
        />
      )}
    </GridBox>
  );
};
